module.exports = __webpack_public_path__ + "img/3.b04aaed6.jpg";